module.exports = __webpack_public_path__ + "static/media/Why-Jagnipur.a182ead7.jpg";